<div class="mobile-sidebar" [class.open]="isOpen">
  <nav class="mobile-sidebar__nav">
    <ng-container *ngIf="(isLoggedIn$ | async)">
      <app-sidebar-item icon="calendar-clock-outline" label="mealPlanner" link="/meal-planner" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="book-open-page-variant-outline" label="recipes" link="/recipes" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="fridge-outline" label="household" link="/household" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="cart-outline" label="shoppingList" link="/shopping-list" [isExpanded]="true"></app-sidebar-item>
      <!-- Marketplace hidden until feature is deliverable
      <app-sidebar-item icon="storefront-outline" label="marketplace" link="/marketplace" [isExpanded]="true"></app-sidebar-item>
      -->
      <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="format-list-bulleted-square" label="ingredients" link="/ingredients" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdminOrModerator$ | async"
        icon="swap-horizontal"
        label="ingredientAssoc"
        link="/ingredient-associations"
        [isExpanded]="true">
      </app-sidebar-item>
      <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="food-off-outline" label="leftovers" link="/leftovers" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdmin$ | async" icon="progress-clock" label="pending" link="/pending" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="comment-outline" label="feedbacks" link="/feedbacks" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="image-check-outline" label="recipePhotoModeration" link="/recipe-photo-moderation" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdmin$ | async" icon="bullhorn-outline" label="announcements" link="/announcements" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isAdmin$ | async" icon="shield-account-outline" label="admin" link="/admin" [isExpanded]="true"></app-sidebar-item>

      <div class="mobile-sidebar__divider"></div>

      <app-sidebar-item icon="account-circle-outline" label="profile" link="/profile" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item *ngIf="isChef$ | async" icon="book-outline" label="myRecipes" link="/my-recipes" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="heart-outline" label="savedRecipes" link="/saved-recipes" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="cog-outline" label="settings" link="/settings" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="help-circle-outline" label="help" link="/help" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item
            icon="message-alert-outline"
            label="leaveFeedback"
            [isExpanded]="true"
            (click)="openFeedbackDialog()"
      ></app-sidebar-item>
      <app-sidebar-item icon="logout" label="logout" (click)="logout()" [isExpanded]="true"></app-sidebar-item>
    </ng-container> 
    <ng-container *ngIf="!(isLoggedIn$ | async)">
      <app-sidebar-item icon="cellphone-arrow-down" label="download" (click)="navigateTo('/download')" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="file-document-outline" label="terms" (click)="navigateTo('/terms-and-conditions')" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="shield-check-outline" label="privacyPolicy" (click)="navigateTo('/privacy-policy')" [isExpanded]="true"></app-sidebar-item>
      <app-sidebar-item icon="help-circle-outline" label="contactSupport" (click)="navigateTo('/app/help-center')" [isExpanded]="true"></app-sidebar-item>
      <div class="mobile-sidebar__divider"></div>
    </ng-container>
  </nav>
</div>

<div class="mobile-sidebar__backdrop" *ngIf="isOpen" (click)="close()"></div>

  
